import React from "react";
import { Avatar } from "antd";
import { FaBell } from "react-icons/fa";
import { GoHome } from "react-icons/go";
import { Link, useLocation } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import useAuthStore from "../store/authStore";
import NotificationDropdown from "./common/notification/NotificationDropdown";
import { FaBars } from "react-icons/fa";
import { getDashboard as getAdminDashboard } from "../api/AdminRequest";
import { getDashboard as getManagerDashboard } from "../api/ManagerRequestApi";

function HeaderAll({ onMenuClick }) {
  const { user, userType } = useAuthStore();
  const [bidRequestCount, setBidRequestCount] = React.useState(0);

  const location = useLocation();
  const { pathname } = location;
  // ... getPageName function remains the same ...
  const getPageName = (pathname) => {
    switch (pathname) {
      case "/":
        return "Dashboard";
      case "/buyer-list":
        return "Buyer List";
      case "/buyer-verify-request":
        return "Verify Buyer Request";
      case "/buyer-single-view":
        return "Buyer Detailed View";
      case "/group-single-view":
        return "Group Detailed View";
      case "/group-list":
        return "Group List";
      case "/manage-content":
        return "Manage-Content";
      case "/manager-list":
        return "Manager List";
      case "/manager-create":
        return "Create Manager";
      case "/manager-edit":
        return "Edit Manager";
      case "/manager-single-view":
        return "Manager Detailed View";
      case "/setting":
        return "Settings";
      case "/manager":
        return "Dashboard";
      case "/manager/settings":
        return "Settings";
      case "/bid-list":
        return "Bid List";
      case "/bid-detailed-view":
        return "Bid Detailed View";
      case "/bid-approve":
        return "Bid Approval";
      case "/bid-request":
        return "Bid Request";
      case "/survey-list":
        return "Survey List";
      case "/survey-create":
        return "Create Survey";
      case "/survey-update":
        return "Edit Survey";
      case "/survey-assign":
        return "Assign Survey";
      case "/survey-single-view":
        return "Survey Detailed View";
      case "/surveyor-list":
        return "Surveyor List";
      case "/surveyor-create":
        return "Create Surveyor";
      case "/surveyor-edit":
        return "Edit Surveyor";
      case "/manager/surveyrequest":
        return "Survey Request";
      case "/surveyor-single-view":
        return "Surveyor Detailed View";
      case "/view-bids":
        return "View Bids";
      case "/survey-settlement":
        return "Survey Settlements";
      case "/create-bid":
        return "Create Bid";
      case "/category":
        return "Category List";
      case "/create-category":
        return "Create Category";
      default:
        return "Not Found"; // Fallback for undefined routes
    }
  };

  React.useEffect(() => {
    const fetchCount = async () => {
      try {
        const fetchFn = userType === "admin" ? getAdminDashboard : getManagerDashboard;
        const { data } = await fetchFn();
        if (data?.success) {
          setBidRequestCount(data?.bidStatusCountResult?.pending || 0);
        }
      } catch (error) {
        console.error("Failed to fetch bid request count:", error);
      }
    };
    if (userType) {
      fetchCount();
    }
  }, [userType]);

  return (
    <div className="flex items-center justify-between px-4 py-3 md:px-6 md:py-4">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 hover:bg-gray-100 rounded-md transition-colors text-indigo-700"
          aria-label="Open Menu"
        >
          <FaBars className="text-xl" />
        </button>

        <div className="flex items-center overflow-hidden">
          <Link to="/" className="flex-shrink-0">
            <GoHome className="text-[#C7C7C7] text-[22px] md:text-[24px]" />
          </Link>
          <span className="ml-2 text-[#313131] truncate text-base md:text-lg font-semibold whitespace-nowrap">
            / {getPageName(pathname)}
          </span>
        </div>
      </div>

      <div className="flex items-center space-x-3 md:space-x-4">
        {pathname !== "/bid-request" && (
          <div className="flex items-center border border-[#9FACF0] p-0.5 px-1 rounded-lg bg-white shadow-sm h-8 md:h-9">
            <div className="px-1 md:px-2 flex items-center gap-1 md:gap-2">
              <span className="text-[10px] md:text-sm font-semibold text-gray-700 whitespace-nowrap">
                <span className="hidden xs:inline">Bid Request</span>
                <span className="xs:hidden">Bid</span>
              </span>
              <span className="text-[#1955EB] font-bold text-[10px] md:text-sm">{bidRequestCount}</span>
            </div>
            <Link to="/bid-request">
              <button className="bg-[#1955EB] text-white font-bold h-6 md:h-7 px-2 md:px-4 text-[9px] md:text-xs rounded-md hover:bg-blue-700 transition-all shadow-sm active:scale-95">
                Open
              </button>
            </Link>
          </div>
        )}
        <NotificationDropdown />
        <div className="hidden sm:flex items-center gap-3">
          <Avatar
            size={36}
            icon={<UserOutlined />}
            className="border-2 border-indigo-100"
          />
          <div className="text-sm font-bold text-gray-700">{user?.name}</div>
        </div>
        <div className="sm:hidden">
          <Avatar
            size={32}
            icon={<UserOutlined />}
          />
        </div>
      </div>
    </div>
  );
}

export default HeaderAll;
